import { Component } from '@angular/core';

@Component({
  selector: 'app-contratos-integrados',
  templateUrl: './contratos-integrados.component.html',
  styleUrl: './contratos-integrados.component.css'
})
export class ContratosIntegradosComponent {

}
